<div
  class="d-flex justify-content-center rounded-top background-color position-relative"
>
  <div id="nav-tab" role="tablist" class="nav">
    <a
      class="nav-link nav-link-left text-lg pointer"
      id="nav-home-tab"
      data-toggle="tab"
      (click)="changeContent('information')"
      role="tab"
      aria-controls="nav-home"
      aria-selected="true"
      [class.tab-active]="currentContent === 'information'"
      >Información</a
    >
    <a
      class="nav-link nav-link-right text-lg pointer"
      id="nav-contact-tab"
      data-toggle="tab"
      (click)="changeContent('gallery')"
      role="tab"
      aria-controls="nav-contact"
      aria-selected="false"
      [class.tab-active]="currentContent === 'gallery'"
      >Galería</a
    >
    <a
      *ngIf="
        client.contact_form.modal === 'BOTH' ||
        client.contact_form.modal === 'MODAL'
      "
      class="nav-link text-lg pointer"
      id="nav-contact-tab"
      data-toggle="tab"
      (click)="changeContent('contact')"
      role="tab"
      aria-controls="nav-contact"
      aria-selected="false"
      [class.tab-active]="currentContent === 'contact'"
      >Contacto</a
    >
  </div>
  <div class="nav mr-3 close">
    <button
      type="button"
      (click)="closeMe()"
      class="close text-light"
      aria-label="Close"
    >
      <span aria-hidden="true">×</span>
    </button>
  </div>
</div>
<div class="rounded-bottom height-content sub-pane" id="nav-tabContent">
  <app-information
    [name]="item.name"
    [description]="item.description"
    [detail]="item.detail"
    [gallery]="item.gallery"
    [url]="item.visor"
    *ngIf="currentContent === 'information'"
  ></app-information>
  <app-visualizator
    [url]="item.visor"
    *ngIf="currentContent === '360'"
  ></app-visualizator>
  <app-contact-form
    [item]="item"
    *ngIf="currentContent === 'contact'"
  ></app-contact-form>
  <app-gallery
    [gallery]="item.gallery"
    *ngIf="currentContent === 'gallery'"
  ></app-gallery>
</div>
